import React from 'react';
import { Provider } from 'react-redux';
import GlobalStyles from '@ease/assets/styles/globalStyle';
import EaseStyles from '@ease/assets/styles/easeAdminStyle';
import { store } from './redux/store';
import Boot from './redux/boot';
import Routes from './router';
import AppProvider from './AppProvider';

const App = () => (
  <Provider store={store}>
    <AppProvider>
      <>
        <GlobalStyles />
        <EaseStyles />
        <Routes />
      </>
    </AppProvider>
  </Provider>
);
Boot()
  .then(() => App())
  .catch(error => console.error(error));

export default App;
